import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Facebook, Instagram, Music2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CHANNELS = [
  { key: "instagram_url", title: "Instagram", note: "Photos, reels and new arrivals", Icon: Instagram },
  { key: "tiktok_url", title: "TikTok", note: "Short videos from the shop floor", Icon: Music2 },
  { key: "facebook_url", title: "Facebook", note: "Updates, offers and reviews", Icon: Facebook },
];

export default function SocialLinks() {
  const { branch } = useParams();
  const [links, setLinks] = useState({});

  useEffect(() => {
    axios
      .get(`${API}/public/social/${String(branch || "").toUpperCase()}`)
      .then(({ data }) => setLinks(data))
      .catch(() => setLinks({}));
  }, [branch]);

  const available = CHANNELS.filter((c) => links[c.key]);

  return (
    <div
      className="min-h-screen bg-[#0B2027] px-6 py-14 text-white sm:px-10"
      data-testid="social-links-page"
    >
      <div className="mx-auto max-w-md">
        <p className="text-[11px] font-semibold uppercase tracking-[0.35em] text-[#C5A059]">
          Dhunna Jewellers {String(branch || "").toUpperCase()}
        </p>
        <h1 className="mt-3 text-4xl font-bold sm:text-5xl">Follow us</h1>
        <p className="mt-2 text-base text-[#8FD3C7]">
          Pick where you would like to browse — new arrivals, offers and behind the counter.
        </p>

        <div className="mt-10 space-y-3" data-testid="social-links-list">
          {available.map(({ key, title, note, Icon }) => (
            <a
              key={key}
              href={links[key]}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-4 border border-[#1D3D46] bg-[#0F2A32] p-5 transition-colors duration-150 hover:border-[#C5A059] hover:bg-[#12313A]"
              data-testid={`social-link-${title.toLowerCase()}`}
            >
              <Icon className="h-7 w-7 shrink-0 text-[#C5A059]" />
              <span>
                <span className="block text-lg font-bold">{title}</span>
                <span className="block text-sm text-[#8FD3C7]">{note}</span>
              </span>
            </a>
          ))}
          {available.length === 0 && (
            <p className="text-sm text-[#8FD3C7]" data-testid="social-links-empty">
              Our channels are being set up — please ask our staff.
            </p>
          )}
        </div>

        <p className="mt-10 text-xs uppercase tracking-[0.25em] text-[#5E7C84]">
          dhunnajewellers.com.au
        </p>
      </div>
    </div>
  );
}
